// action
import {
    SAVE_PATIENT,
    SAVE_PATIENT_FAIL,
    SAVE_PATIENT_SUCCESS,
    SAVE_PATIENT_RESET
} from '../action/savePatientAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SAVE_PATIENT:
            return {
                ...state,
                apiState: "loading"
            }
        case SAVE_PATIENT_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case SAVE_PATIENT_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case SAVE_PATIENT_RESET:
            return initialState
        default:
            return state
    }
}